// extracted by mini-css-extract-plugin
var _1 = "Address_container__-Lez8";
var _2 = "Address_header__9wJaB";
var _3 = "Address_modal__M8nEX";
var _4 = "Address_title__3BFUB";
export { _1 as "container", _2 as "header", _3 as "modal", _4 as "title" }
